<template>
    <div v-if="!list.loading" class="side-menu">
        <b class="heading">
            Filters

            <i v-if="space_permission('SEARCH_CREATE')"
               class="add-topic icon fas fa-plus-square is-pulled-right pointer"
               @click="show_modal = true"></i>
        </b>

        <saved-search-modal
            v-if="show_modal"
            :space="space"
            :saved_search="editing_search"
            @close="close_modal"/>

        <saved-search-item
            v-for="saved_search in saved_searches"
            :saved_search="saved_search"
            :space="space"
            :key="saved_search.id"
            @edit="edit"/>

        <a v-if="list.data.results && list.data.results.length > 4"
           @click="expand = !expand"
           class="menu-item">
            <span v-if="!expand">All Filters...</span>
            <span v-else>Show less...</span>
        </a>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import SavedSearchItem from './SavedSearchItem.vue';
import SavedSearchModal from './SavedSearchModal.vue';

export default {
    name: 'SavedSearches',
    components: { SavedSearchModal, SavedSearchItem },
    props: ['space'],
    data() {
        return { editing_search: null, show_modal: false, expand: false };
    },
    computed: {
        ...mapState('saved_searches', ['list']),
        saved_searches() {
            if (!this.expand && this.list.data.results) {
                return this.list.data.results.slice(0, 4);
            }
            return this.list.data.results;
        },
    },
    created() {
        this.$store.dispatch('saved_searches/list', { space_id: this.space.id });
    },
    methods: {
        edit(saved_search) {
            this.editing_search = saved_search;
            this.show_modal = true;
        },
        close_modal() {
            this.editing_search = null;
            this.show_modal = false;
        },
    },
};
</script>
